export enum BidResult {
  HOLD_SEAT = 'HOLD_SEAT',
  PENDING_SEAT = 'PENDING_SEAT',
  PROCESSING = 'PROCESSING',
  AUCTION_CLOSING = 'AUCTION_CLOSING',
  OUT_BID = 'OUT_BID',
  // After auction is closed:
  SUCCESSFUL = 'SUCCESSFUL',
  UNSUCCESSFUL = 'UNSUCCESSFUL',
}
